module.exports = __webpack_public_path__ + "static/media/NoTicket.af72889d.png";